<template>
  <Parametros />
</template>

<script>
import Parametros from "../components/Parametros";

export default {
  name: "Home",
  components: {
    Parametros,
  },
};
</script>
